import React from 'react';
import EmptyMessage from 'src/components/emptyMessage';

import styles from './notFound.module.scss';

interface NotFoundMessageProps {
  message?: string;
  secondaryMessage?: string;
}

interface SimulationNotFoundMessageProps extends NotFoundMessageProps {}

const SimulationNotFoundCopy: React.FC<SimulationNotFoundMessageProps> = ({
  message = "The simulation you're trying to access is no longer available.",
  secondaryMessage = "",
}) => (
  <div className={styles.notFoundContent}>
    <h1 className={styles.notFoundHeading}>
      <span>Simulation unavailable</span>
    </h1>
    <p className={styles.notFoundMessage}>{message}</p>
    {secondaryMessage && (
      <p className={styles.notFoundMessage}>{secondaryMessage}</p>
    )}
  </div>
);

export const SimulationNotFoundMessage: React.FC<SimulationNotFoundMessageProps> = (props) => (
  <div className={styles.notFoundPanel}>
    <SimulationNotFoundCopy {...props} />
  </div>
);

interface CourseNotFoundProps {
  onBack: () => void;
  message?: string;
  secondaryMessage?: string;
}

export const CourseNotFound: React.FC<CourseNotFoundProps> = ({
  onBack,
  message = "The course you're trying to access is no longer available.",
  secondaryMessage = "",
}) => {
  const handleBackClicked = () => {
    onBack();
  };

  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={handleBackClicked}>
        <i className="paperflite-left-arrow"></i>
        <span>my courses</span>
      </div>
      <div className={styles.body}>
        <div className={styles.notFoundContent}>
          <h1 className={styles.notFoundHeading}>
            <span>Course unavailable</span>
          </h1>
          <p className={styles.notFoundMessage}>{message}</p>
          {secondaryMessage && (
            <p className={styles.notFoundMessage}>{secondaryMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
};

interface SimulationNotFoundProps {
  onBack: () => void;
  message?: string;
  secondaryMessage?: string;
}

export const SimulationNotFound: React.FC<SimulationNotFoundProps> = ({
  onBack,
  message = "The simulation you're trying to access is no longer available..",
  secondaryMessage = "",
}) => {
  const handleBackClicked = () => {
    onBack();
  };

  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={handleBackClicked}>
        <i className="paperflite-left-arrow"></i>
        <span>my courses</span>
      </div>
      <div className={styles.body}>
        <SimulationNotFoundCopy
          message={message}
          secondaryMessage={secondaryMessage}
        />
      </div>
    </div>
  );
};

interface PodcastNotFoundProps {
  onBack: () => void;
}
export const PodcastNotFound: React.FC<PodcastNotFoundProps> = ({ onBack }) => {

  const handleBackClicked = () => {
    onBack();
  };

  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={handleBackClicked}>
        <i className="paperflite-left-arrow"></i>
        <span>my courses</span>
      </div>
      <div className={styles.body}>
        <EmptyMessage
          width="auto"
          image={'/images/page_not_found.svg'}
          heading="Podcast not found!"
          message="The podcast does not exist."
        />
      </div>
    </div>
  );
};